import { Box } from "@mui/material";
import { Card } from "src/components/atoms/Card";
import { DashboardSummaryCard } from "../DashboardSummaryCard";
import { useNoboEventCounts } from "../../hooks";

export function DashboardNoboEventsSummary() {
  const noboCounts = useNoboEventCounts();

  return (
    <Card title="Nobos" sx={{ mb: 6 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr" },
          gap: 4,
          maxWidth: "50%",
        }}
      >
        <DashboardSummaryCard
          title="Nobo Requests"
          items={[
            {
              label: "Pending approval",
              value: noboCounts.pendingApproval,
              href: "/nobo-events?view=pending_approval",
              color: "#F57C00",
            },
            {
              label: "Pending delivery",
              value: noboCounts.pendingDelivery,
              href: "/nobo-events?view=pending_delivery",
              color: "#1976D2",
            },
            {
              label: "Recently delivered",
              value: noboCounts.recentlyDelivered,
              href: "/nobo-events?view=recently_delivered",
              color: "#388E3C",
            },
          ]}
        />
      </Box>
    </Card>
  );
}
